<template>
  <div class="pa-1">
    <v-hover v-if="!edit" v-slot="{ hover }">
      <v-chip color="green">
        <div class="white--text px-2">
          {{ value }}
        </div>

        <template v-if="hover">
          <span
            v-if="editable"
            style="color: white"
            class="me-1 flaticon2-edit pointerCursor"
            title="ویرایش"
            @click="edit = true"
          />

          <span
            v-if="editable"
            style="color: white"
            class="me-1 flaticon2-rubbish-bin-delete-button pointerCursor"
            title="حذف"
            @click="$emit('delete', value)"
          />
          <!-- <span
            v-if="obj.show && admin"
            style="color: white"
            class="me-1 flaticon2-delete pointerCursor"
            title="رد"
            @click="$emit('show', obj.id)"
          /> -->
          <!-- <span
            v-if="!obj.show && admin"
            style="color: white"
            class="me-1 flaticon2-check-mark pointerCursor"
            title="تایید"
            @click="$emit('show', obj.id)"
          /> -->
        </template>
      </v-chip>
    </v-hover>

    <v-text-field
      v-else
      v-model="editableText"
      :rules="[(v) => !!v || 'مقدار نباید خالی باشد']"
      append-icon="mdi-check"
      type="text"
      class="rounded-lg"
      clearable
      dense
      outlined
      @click:clear="cancel"
      @click:append="submit"
    />
  </div>
</template>

<script>
export default {
  name: "NumberTrans",

  props: {
    obj: Object,
    editable: {
      type: Boolean,
      default: true,
    },
    value: String,
    checkInput: [Function],
    admin: Boolean,
  },

  data() {
    return {
      edit: false,
      editableText: "",
    };
  },

  watch: {
    edit(val) {
      if (val) {
        this.editableText = this.value;
      } else {
        this.editableText = "";
      }
    },
  },

  methods: {
    cancel() {
      this.edit = false;
      this.editableText = "";
    },
    async submit() {
      if (await this.$modal.yesNo(`آیا از شماره  خود اطمینان دارید`)) {
        if (this.checkInput(this.editableText)) {
          this.$emit("input", this.editableText);
          this.cancel();
        }
      } else {
        this.cancel();
      }
    },
  },
};
</script>

<style scoped>
.pointerCursor {
  cursor: pointer;
}
</style>
